// extracted by mini-css-extract-plugin
export default {"wrap":"insights_page-module___wrap___ddd58789"};